export { releaseNoteQueryKeys } from "@donista/shared/query-keys/release-notes";
